import { Notification } from 'element-ui'
import crypto from 'crypto';

/**
 * 将对象存入localStorage
 */
window.set_localStorage = (key, obj) => {
  window.localStorage.setItem(key, JSON.stringify(obj))
}

/**
 * 从localStorage中获取数据
 */
window.get_localStorage = key => JSON.parse(localStorage.getItem(key))


/**
 * returnMD5
 * MD5加密
 */
window.getMD5 = (pwd) => {
  var md5 = crypto.createHash("md5");
  md5.update(pwd);
  return md5.digest('hex');
}

/**
 * 根据cookie名字获取cookie
 */
window.getCookie = name => {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return (arr[2]);
  } else {
    return undefined;
  }
}

/**
 * 删除cookie中的用户token
 */
window.delUserTokenFromCookie = () => {
  return delCookie('USER_TOKEN_COOKIE');
}
/**
 * 删除cookie
 */
window.delCookie = name => {
  $cookies.remove(name);
}
/**
 * 清空cookie及localStorage中的用户信息，并跳到登录页面
 */
window.gotoLoginPage = (next) => {
  //  清除token
  delUserTokenFromCookie()
  //  本地用户信息
  //localStorage.clear()

  //  提示
  errorMsg({
    message: '登录过期'
  })

  //统一门户：跳转到登录页
  next({
    name: 'login'
  })
}


/**
 * 消息提示
 */
let notify = type => {
  return ({
            //  消息默认值 空
            message = '',
            //  标题默认值 空
            title = '系统提示',
            //  通知默认显示时间 - 2s
            duration = 2000,
            //  通知默认显示位置 - 右下
            position = 'bottom-right'
          }) => {
    Notification[type]({
      title,
      message,
      duration,
      position
    })
  }
};

/**
 * 消息通知 - 成功
 */
window.successMsg = notify('success')

/**
 * 消息通知 - 失败/错误
 */
window.errorMsg = notify('error')

/**
 * 消息通知 - 信息
 */
window.infoMsg = notify('info')

/**
 * 消息通知 - 警告
 */
window.warningMsg = notify('warning')

window.formatDate = function (value) {
  if (value == null || value == '') return '';
  var now = new Date(parseInt(value) * 1000);
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  var date = now.getDate();
  if (date < 10) {
    date = "0" + date;
  }
  return year + "-" + month + "-" + date;
}


//日期转换
window.formatDateTime = function (value) {
  if (value == null || value == '') return '';
  var now = new Date(parseInt(value) * 1000);
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  var date = now.getDate();
  if (date < 10) {
    date = "0" + date;
  }
  var hour = now.getHours();
  if (hour < 10) {
    hour = "0" + hour;
  }
  var minute = now.getMinutes();
  if (minute < 10) {
    minute = "0" + minute;
  }
  var second = now.getSeconds();
  if (second < 10) {
    second = "0" + second;
  }
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

/**
 *对Date的扩展，将 Date 转化为指定格式的String
 *月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *例子：
 *(new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 *(new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}


window.butelCdnUrl = "http://114.112.74.78"
